export default __webpack_public_path__ + "static/media/download-dark.eca94b95.svg";